/**
 * Airborn Cart — "Remove" text label
 *
 * Dawn's remove-from-cart button is normally just an icon with an
 * aria-label (e.g. aria-label="Remove Beige") — there's no visible text
 * node for CSS to reveal. This script finds each remove button, hides
 * its icon, and inserts a plain "Remove" text node instead — without
 * needing to know or edit the cart's liquid markup.
 *
 * Runs on page load AND after cart updates (Dawn's cart re-renders items
 * via AJAX when quantity changes, so buttons added after the initial
 * load need this too — hence the MutationObserver).
 */
function airbornAddRemoveLabels() {
  // Matches Dawn's common remove-button patterns without needing an
  // exact class name — any link/button whose aria-label starts with
  // "Remove" inside the cart items area.
  document.querySelectorAll('#main-cart-items [aria-label^="Remove" i]').forEach((button) => {
    if (button.querySelector('.airborn-remove-label')) return; // already labeled

    // Hide the icon (svg or img) inside the button, keep it in the DOM
    // in case you ever want to bring it back
    button.querySelectorAll('svg, img').forEach((icon) => {
      icon.style.display = 'none';
    });

    const label = document.createElement('span');
    label.className = 'airborn-remove-label';
    label.textContent = 'Remove';
    button.appendChild(label);
  });
}

document.addEventListener('DOMContentLoaded', airbornAddRemoveLabels);

// Re-run whenever the cart items re-render (e.g. after a quantity change)
const airbornCartItemsRoot = document.getElementById('main-cart-items');
if (airbornCartItemsRoot) {
  new MutationObserver(airbornAddRemoveLabels).observe(airbornCartItemsRoot, {
    childList: true,
    subtree: true,
  });
}
